import { createStore } from "vuex";

import { generateArr } from "@/utils/array"; 

const imageMap = {};

generateArr(5).forEach(number => {
    imageMap[`image-${number+1}`] = false;
});

export default createStore({
    state: {
        imageMap,
        pct: 0
    },
    mutations: {
        flip(state, imageId) {
            state.imageMap[imageId] = true;
        },
        updatePct(state, pct) {
            state.pct = pct;
        }
    }
});